import React from 'react'
import FilterTabs from 'components/filterTabs'
import { staticFilterPage } from 'enums/staticFilterPage'
import { AVAILABLE_COLUMNS } from 'store/modules/bottlesFilter/columns'

export default () => {
  return <FilterTabs page={staticFilterPage.bottles} availableColumns={AVAILABLE_COLUMNS} />
}
